// extracted by mini-css-extract-plugin
export default {"title":"WarnMessage_title","description":"WarnMessage_description"};